<template>
  <!-- 变更启租日期 -->
  <div>
    <h1 class="item-title">{{ $t('components_contract_change_startdate.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_startdate.he_tong_lei_xing') }}:</span>
          <span class="value">{{ getDicValue('crm_contract_type', detail.contractType) }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_startdate.he_tong_bian_hao') }}:</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_startdate.sghth') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_startdate.jfsqdbgs') }}:</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_startdate.yi_fang') }}:</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_startdate.shou_hou_gong_si') }}:</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_startdate.xiang_mu_ming_cheng') }}:</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="16">
          <span class="label">{{ $t('components_contract_change_startdate.shi_yong_di_dian') }}:</span>
          <span class="value">{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city || '' }}{{ detail.useAddress }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_contract_change_startdate.shen_qing_xin_xi') }}</h1>
    <div style="margin-bottom: 30px">
      <custom-table ref="customTb1" v-model="selectDevice" type="checkbox" tableCode="changeStartDate" :data="dataList" @filter="filterChange" @sort="sortChange" :slots="['newStartDate', 'action']">
        <template slot="newStartDate" slot-scope="scope">
          <custom-date-picker
            style="width: 98%"
            v-model="scope.row.newRentTime"
            align="right"
            type="date"
            :disabled="model.type === 'watch'"
            value-format="YYYY-MM-DD HH:mm:ss"
            @change="changeDate(scope.row)"
            :picker-options="
              unlimited
                ? null
                : {
                    disabledDate(time) {
                      if (!scope.row.rentalStartTime) {
                        return false;
                      }
                      return (
                        time.getTime() > new Date(`${scope.row.rentalStartTime}Z`).getTime() ||
                        time.getTime() > Date.now() ||
                        time.getTime() < new Date(`${scope.row.rentalStartTime.slice(0, 7)}-01 00:00:00Z`).getTime() - 86400000
                      );
                    },
                  }
            "
          ></custom-date-picker>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" :disabled="!scope.row.newRentTime || (model.row && model.row.changeState == 10)" @click="onPreview(scope.row)">
            {{ $t('components_contract_change_startdate.yu_lan_zhang_dan') }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <el-form :model="form" :inline="true" :rules="rules" ref="form" label-width="86px">
      <el-form-item :label="$t('components_contract_change_startdate.shen_qing_miao_shu')" prop="changeDesc">
        <el-input type="textarea" :rows="3" :disabled="model.type === 'watch'" :placeholder="$t('components_contract_change_startdate.qsrbgdyy')" v-model="form.changeDesc" style="width: 636px"></el-input>
      </el-form-item>
    </el-form>
    <!-- 预览账单 -->
    <preview-bill-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></preview-bill-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import previewBillDialog from './children/preview_bill_dialog.vue';

export default {
  components: { previewBillDialog },
  props: {
    unlimited: { type: Boolean, default: false },
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
        };
      },
    },
  },
  data() {
    return {
      dialogModel: {},
      dialogVisible: false,
      dataList: [],
      detail: {},
      selectDevice: [],
      form: {
        changeOrderId: '',
        orderId: '',
        changeDesc: '',
        changeOrderDevices: [],
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        changeDesc: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
      };
    },
  },
  methods: {
    // 解决变更的时分秒要和启租的时分秒相同
    changeDate(row) {
      const newRentTime = `${this.$momentElLocal(row.newRentTime).slice(0, 10)} ${this.$momentElLocal(row.rentalStartTime).slice(11, 19)}`;
      row.newRentTime = this.$momentWorld(newRentTime);
    },
    // 预览账单
    onPreview: function (row) {
      this.dialogModel.title = this.$t('components_contract_change_startdate.yu_lan_zhang_dan');
      this.dialogModel.type = 'change_startdate';
      this.dialogModel.row = Object.assign({}, this.detail, row);
      this.dialogVisible = true;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo();
        this.getDeviceList();
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            item.newRentTime = item.newRentTime;
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },
    // 订单信息
    getOrderInfo: function () {
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.OrderChangeInfo, {
        changeOrderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.orderId,
        showDeviceType: 1,
        bizState: ['22'],
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.oldRentTime = item.rentalStartTime;
          item.newRentTime = '';
        });
        this.dataList = list;
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find((t) => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.newRentTime = row.newRentTime;
              this.$refs.customTb1.$emit('toggleRowSelection', item, true);
            }
          });
        }
      });
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.selectDevice.length) {
          this.$message.error(this.$t('components_contract_change_startdate.qing_xuan_ze_she_bei'));
          return;
        }
        const hasEmpty = this.selectDevice.find((t) => !t.newRentTime);
        if (hasEmpty) {
          this.$message.error(this.$t('components_contract_change_startdate.qxzxqzrq'));
          return;
        }
        this.form.isStartApprove = approve || 0;
        this.form.changeOrderDevices = this.selectDevice;
        this.$postJSON(apis.ChangeStartDateSave, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
        });
      });
    },
  },
};
</script>

<style lang="scss"></style>
